import { axiosJWTInstance } from "../../../utils/axiosJWTInstance";
import { Dispatch } from "redux";

import {
  GET_SELLER_STATS_ATTEMPT,
  GET_SELLER_STATS_SUCCESS,
  GET_SELLER_STATS_FAILURE,
  GET_SELLER_ORDERS_ATTEMPT,
  GET_SELLER_ORDERS_SUCCESS,
  GET_SELLER_ORDERS_FAILURE,
} from "../../constants";

// getSellerStats actions
const getSellerStatsAttempt = (payload: any) => ({
  type: GET_SELLER_STATS_ATTEMPT,
  payload
});

const getSellerStatsSuccess = (payload: any) => ({
  type: GET_SELLER_STATS_SUCCESS,
  payload,
});

const getSellerStatsFailure = (error: string) => ({
  type: GET_SELLER_STATS_FAILURE,
  payload: {
    error,
  },
});

export const getSellerStatsRequest = (data: any, paramsToAdd: any) => (dispatch: Dispatch) => {
  dispatch(getSellerStatsAttempt(data));

  const params2 = {
    entity: "seller_stats",
    ...paramsToAdd
  }

  const searchParams = new URLSearchParams(params2);
  const webUrl = `/Orders?${searchParams.toString()}`;

  return axiosJWTInstance
    .post(webUrl, data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "content-type": "application/json",
      }
    })
    .then((res) => res.data)
    .then((payload) => {
      dispatch(getSellerStatsSuccess(payload));
    })
    .catch((error) => {
      dispatch(getSellerStatsFailure(error.message));
    });
};

// getSellerOrders actions
const getSellerOrdersAttempt = (payload: any) => ({
  type: GET_SELLER_ORDERS_ATTEMPT,
  payload
});

const getSellerOrdersSuccess = (payload: any) => ({
  type: GET_SELLER_ORDERS_SUCCESS,
  payload,
});

const getSellerOrdersFailure = (error: string) => ({
  type: GET_SELLER_ORDERS_FAILURE,
  payload: {
    error,
  },
});
